import { render, staticRenderFns } from "./Zdyloading.vue?vue&type=template&id=56278ffb&scoped=true"
import script from "./Zdyloading.vue?vue&type=script&lang=js"
export * from "./Zdyloading.vue?vue&type=script&lang=js"
import style0 from "./Zdyloading.vue?vue&type=style&index=0&id=56278ffb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56278ffb",
  null
  
)

export default component.exports